import React from "react";
import { AlertTriangle } from "lucide-react";
import { fmtNum, KIND_LABEL } from "./sections";

export function RegistrationBar({ reg }) {
    if (!reg) return null;
    const align = reg.metodo === "hough" ? `${Math.round((reg.confidenza || 0) * 100)}% quote concordanti` : "adattamento ingombri";
    return (
        <div className="flex flex-wrap gap-x-6 gap-y-1 text-xs text-slate-500 bg-white border border-slate-200 px-4 py-3" data-testid="result-registration">
            <span>Scala PDF: <strong className="text-cb-dark">{reg.scala || "—"}</strong></span>
            <span>Allineamento: <strong className="text-cb-dark">{align}</strong></span>
            <span>Unità DXF: <strong className="text-cb-dark">{reg.unita_dxf}</strong></span>
            <span>Tratti: <strong className="text-cb-dark">{reg.tratti_accoppiati}</strong> doppia linea · <strong className="text-cb-dark">{reg.tratti_singoli}</strong> singoli · <strong className="text-cb-dark">{reg.flessibili}</strong> flex</span>
            <span>Quote PDF: <strong className="text-cb-dark">{reg.quote_pdf}</strong></span>
        </div>
    );
}

export function FittingsCard({ fittings }) {
    if (!fittings?.length) return null;
    return (
        <div className="bg-white border border-slate-200 p-6" data-testid="result-fittings">
            <h3 className="font-display text-xl font-bold text-cb-dark mb-4">Pezzi speciali rilevati</h3>
            <table className="w-full text-sm">
                <thead>
                    <tr className="border-b border-slate-200 text-slate-500 text-xs uppercase tracking-wider">
                        <th className="text-left py-2 font-medium">Rete</th>
                        <th className="text-left py-2 font-medium">Tipo</th>
                        <th className="text-right py-2 font-medium">Q.tà</th>
                        <th className="text-right py-2 font-medium">L. equiv.</th>
                    </tr>
                </thead>
                <tbody>
                    {fittings.map((f, i) => (
                        <tr key={`${f.kind}-${f.type}`} className="border-b border-slate-100 last:border-0" data-testid={`fitting-row-${i}`}>
                            <td className="py-1.5 text-slate-600">{KIND_LABEL[f.kind] || f.kind}</td>
                            <td className="py-1.5 capitalize text-cb-dark">{f.type}</td>
                            <td className="py-1.5 text-right font-semibold tabular-nums">{f.count}</td>
                            <td className="py-1.5 text-right tabular-nums text-slate-600">{fmtNum(f.eq_length_m)} m</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="mt-3 text-[11px] text-slate-400">Blocchi CAD (curve, riduzioni, derivazioni, serrande, tappi). La lunghezza equivalente è già inclusa nelle righe "pezzi speciali" delle tabelle.</div>
        </div>
    );
}

export function TotalsCards({ result, totalMR, totalAltro, hasAltro }) {
    return (
        <div className="grid md:grid-cols-3 gap-4">
            <div className="bg-cb-dark text-white p-6" data-testid="result-plenum">
                <div className="text-xs uppercase tracking-[0.2em] text-slate-400">Plenum totali</div>
                <div className="font-display text-4xl font-bold mt-2">{result.plenum_count}</div>
            </div>
            <div className="bg-cb-dark text-white p-6" data-testid="result-griglie">
                <div className="text-xs uppercase tracking-[0.2em] text-slate-400">Griglie totali</div>
                <div className="font-display text-4xl font-bold mt-2">{result.griglia_count}</div>
            </div>
            <div className="bg-cb-accent text-white p-6 flex flex-col justify-between" data-testid="result-total">
                <div className="text-xs uppercase tracking-[0.2em] text-white/80">Totale lamiera M+R</div>
                <div className="font-display text-4xl font-bold mt-2">{fmtNum(totalMR)} m²</div>
                {hasAltro && <div className="text-xs text-white/80 mt-1">+ {fmtNum(totalAltro)} m² altra rete</div>}
            </div>
        </div>
    );
}

export function AnomaliesBox({ warnings = [], anomalies = [] }) {
    if (!warnings.length && !anomalies.length) return null;
    return (
        <div className="border border-amber-300 bg-amber-50 p-6" data-testid="result-anomalies">
            <div className="flex items-center gap-2 text-amber-800 font-semibold mb-3">
                <AlertTriangle size={18} /> Note e anomalie di rilevamento
            </div>
            <ul className="text-sm text-amber-900 space-y-1 list-disc pl-5">
                {warnings.map((w) => <li key={`w-${w}`}>{w}</li>)}
                {anomalies.map((a) => <li key={`a-${a.kind}-${a.detail}`}>{a.detail}</li>)}
            </ul>
        </div>
    );
}
